import BannersContent from "./BannersContent";

export default BannersContent;
